import { styled } from '@mui/material/styles';
import type { JSX } from 'react';

const StyledSvg = styled('svg')`
  path {
    fill: ${({ theme }) => theme.palette.primary.contrastText};
  }
`;

export const SendIcon = (): JSX.Element => {
  return (
    <StyledSvg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4209 0.329249C15.2794 0.187873 15.1028 0.086766 14.9093 0.036342C14.7157 -0.014082 14.5123 -0.0119997 14.3198 0.0423744H14.3092L0.813458 4.13737C0.594361 4.20052 0.399623 4.32875 0.25505 4.50507C0.110476 4.68139 0.0228936 4.89748 0.00390759 5.1247C-0.0150785 5.35192 0.0354285 5.57955 0.148735 5.77742C0.262042 5.97529 0.4328 6.13406 0.63838 6.23269L6.60932 9.14081L9.51322 15.1082C9.60354 15.301 9.74714 15.4638 9.92706 15.5776C10.107 15.6914 10.3157 15.7512 10.5285 15.7502C10.5609 15.7502 10.5932 15.7488 10.6256 15.746C10.8526 15.7276 11.0686 15.6402 11.2445 15.4955C11.4205 15.3509 11.548 15.1559 11.6099 14.9367L15.7021 1.44089C15.7021 1.43737 15.7021 1.43386 15.7021 1.43034C15.7572 1.23836 15.7602 1.03518 15.7108 0.841672C15.6613 0.648161 15.5613 0.471297 15.4209 0.329249ZM10.5349 14.6146L10.5313 14.6245V14.6196L7.71463 8.83284L11.0896 5.45784C11.1907 5.3515 11.2462 5.20989 11.2443 5.06321C11.2424 4.91653 11.1833 4.77639 11.0796 4.67266C10.9759 4.56894 10.8357 4.50983 10.689 4.50795C10.5424 4.50608 10.4007 4.56157 10.2944 4.66261L6.9194 8.03761L1.13057 5.22089H1.12565H1.13549L14.6249 1.12519L10.5349 14.6146Z"
        fill="white"
      />
    </StyledSvg>
  );
};
